import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'
import metrics from './get-metrics'
import last from './get-last'
import pdfInspectionDownload from './pdf-inspection-dowload'
import pdfInspectionFullDownload from './pdf-inspection-full-download'
import { pdf } from '@react-pdf/renderer'

const reducer = combineReducers({
  selected,
  last,
  all,
  newOne,
  editOne,
  deleteOne,
  metrics,
  pdfInspectionDownload,
  pdfInspectionFullDownload,
})

export default reducer
